import React from 'react';
import bem from 'utils/bem';
import FormikCheckboxField from 'forms/fields/CheckboxField/FormikCheckboxField';
import './index.sass';

const { block } = bem('cancel-rules-field');
const CancelRulesCheckboxField = ({name, ...rest}) => {

    //todo: make conditional from workingOffline text
    const text = `Я ознакомлен, что перенести встречу можно за 24 часа в случае личной встречи, за 12 часов - в случае online-встречи`;

    return (
        <FormikCheckboxField className={ block() } name={name} text={ text } {...rest}/>
    );
};

export default CancelRulesCheckboxField;
